import { NextRouter } from "next/router";

import { CountryData, StoredCountry } from "@/components/Layout/CountrySelector";
import { formateErrorObject } from "@/components/shared/formateErrorObject";
import { notify } from "@/components/shared/notify";

import { CountryState } from "@/atoms/countryState";
import { addToCart, getCartSummary } from "@/services/Cart";
import { CartItem } from "@/utils/interfaces/cart";
import { User } from "@/utils/interfaces/User";

interface IGlobalCountryChange {
  countryList: CountryData[]
  code: string;
  fallbackCountry: CountryData | null
  router: NextRouter
  setCountryState: (valOrUpdater: CountryState | ((currVal: CountryState) => CountryState)) => void
  source: 'manual' | 'auto'
  localUserId: string
  userData?: User | undefined
  cartData: CartItem[]
}

const setLocalStorageWithExpiry = (
  key: string,
  value: any,
  ttlHours = 24,
) => {
  if (typeof localStorage === 'undefined') return;
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttlHours * 60 * 60 * 1000,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

const STORAGE_KEY = 'zebra_selected_country';




export const globalCountryChange = async (data: IGlobalCountryChange) => {


  const handleBulkAddToCart = async (cartData: CartItem[]) => {
    try {
      await getCartSummary();

      if (!cartData || !Array.isArray(cartData)) {
        return;
      }

      const addCartPromises = cartData.map(async (item) => {
        const payload = {
          id: item.product_id as number,
          temp_user_id: data.localUserId,
          quantity: item.quantity || 1,
          trackingData: {
            productData: {
              price: Number(item.price),
              id: Number(item.product_id),
              heading: item.name,
              quantity: item.quantity || 1,
              currency: item?.currency_value,
            },
            userData: data.userData,
            pathname: data.router.pathname,
            productType: item.type === 'Book' ? 'book' : 'course',
            type:
              item.type === 'Bundle'
                ? 'bundles'
                : item.type === 'Book'
                ? 'books'
                : 'courses',
          },
        };

        const response = await addToCart(payload);

        return response?.data;
      });

      const responses = await Promise.all(addCartPromises);

      const lastCart = responses[responses.length - 1];
      const cartId = lastCart?.cart_id || lastCart?.data?.cart_id;

      if (data.router.asPath.includes('/cart/?cartStep=1')) {
        data.router.replace(`/cart/?cartStep=1&cartId=${cartId}`);
      }
      else if (data.router.asPath.includes('/checkout-v2')) {
        // data.router.replace(`/checkout-v2/?cartId=${cartId}`);
        // return cartId;
      }
      else if (data.router.asPath.includes('/checkout')) {
        data.router.replace(`/checkout/?cartId=${cartId}`);
      }
      else {
        data.router.replace(`/cart/?cartId=${cartId}`);
      }
    } catch (error: any) {
      const message = formateErrorObject(error);
      notify(message, 'error');
      if (!data.router.asPath.includes('/checkout-v2/')) {
        data.router.replace('/books/shop/?price=paid');

      }
    } finally {
      data.setCountryState((prev) => ({
        ...prev,
        globalCountryChange: false,
      }));
    }
  };



  if (typeof window === 'undefined') return;

  const country = data.countryList.find((c) => c.code === data.code) || data.fallbackCountry;
  if (!country) return;




  data.setCountryState({
    isOpen: false,
    selectedCountry: {
      ...country,
      currency: country.currency || 'INR',
      currency_symbol: country.currency_symbol || '₹',
      timezone: country.timezone || 'Asia/Kolkata',
    },
    source: data.source,
  });

  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('/api/v4/') && key !== '/api/v4/active-countries') {
      localStorage.removeItem(key);
    }
  });

  if (data.source === 'manual') {
    const localStorageCountry: StoredCountry = { country, source: data.source };
    setLocalStorageWithExpiry(STORAGE_KEY, localStorageCountry);

    document.cookie = `country=${country.code}; path=/; max-age=${60 * 60 * 24}; SameSite=Lax`;
    if (
      data.router.asPath.includes('/cart/') ||
      data.router.asPath.includes('/checkout-v2/') ||
      data.router.asPath.includes('/checkout/')
    ) {
      try {
        await handleBulkAddToCart(data.cartData);
      } catch (err: any) {
        notify(formateErrorObject(err), 'error');
      }
    }
  } else {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ country, source: data.source }),
    );

    document.cookie = `country=${country.code}; path=/; max-age=${60 * 60 * 24
      }; SameSite=Lax`;
  }









  if (
    !data.router.asPath.includes('/cart/') &&
    !data.router.asPath.includes('/checkout-v2/') &&
    !data.router.asPath.includes('/checkout/')
  ) {
    setTimeout(() => window.location.reload(), 300);
  }
}